import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state = {
    activites: [],
    currentActivite: {},
    typesActivites: [],
    filtredActivites: [],
    currentDate : "",
    isDateDiff: false
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
